import React, { useState } from "react";
import { Collapse } from 'react-bootstrap';
import FormContact from "../Form/Form";
import FormMobile from "../Form/FormMobile";
import { BsFillPlayFill, BsPauseFill } from "react-icons/bs";
import { useRef } from "react";
import ButtonList from "../ButtonList/ButtonList";

function GolfLessons() {

    const [open, setOpen] = useState(false);

    const [open1, setOpen1] = useState(false);


    const value = true;

    const playerRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);

    const handlePlayPause = () => {
        const player = playerRef.current;
        if (player) {
            player.contentWindow.postMessage(
                JSON.stringify({
                    method: isPlaying ? 'pause' : 'play',
                    value: null
                }),
                '*'
            );
            setIsPlaying(!isPlaying);
        }
    };


    return (
        <>

            <section id="golf_lessons" className="club_fitting bg_white club_lessons page-section">
                <div className="container-xl">
                    <div className="d-flex align-items-center justify-content-between sec_tile_bar">
                        <div className="">
                            <h2 className="sec_title title_dark">Golf Lessons</h2>
                        </div>
                        <div className="btn-section hide_mobile">
                            <ButtonList />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-4">
                            <div className="card hide_mobile">
                                <div className="card-body">
                                    <h4 className="card-title">Interested in lessons?</h4>
                                    <FormContact />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-8">
                            <div className="video_card pr_img">
                                <div className="ifream-video-box ratio ratio-16x9 iframe_wrapper">
                                    <div id="v-video" className="v-video">
                                        <iframe ref={playerRef} src="https://player.vimeo.com/video/844426147?h=b2407d1914&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;controls=1" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen="" style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }} title="JuniorLandingEnrollConfirmation" data-ready="true"></iframe>
                                    </div>
                                    {/* <div id="v-video-btn" className={isPlaying ? 'play' : 'pause'}>
                                        <button id="play" className="play-btn-view" onClick={handlePlayPause}>
                                            <BsFillPlayFill />
                                        </button>
                                        <button id="pause" className="pause-btn-view" onClick={handlePlayPause}>
                                            <BsPauseFill />
                                        </button>
                                    </div> */}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-6 accordion-item acc_items">
                                    <div className="points_sec">
                                        <h4 className="custom-collapse" id="fitter_p1">
                                            <span className="collapsed" onClick={() => setOpen(!open)} aria-controls="example-collapse-text" aria-expanded={open}>
                                                What do you teach?
                                                <img className="hide_desktop" src={require('../../assets/images/angle_down.png')} />
                                            </span>
                                        </h4>
                                        <Collapse in={open}>
                                            <p id="fitter_pc1" className="accordion-collapse collapse" aria-labelledby="fitter_p1">
                                                We teach optimal match ups. Each student is apporached as an indivdual to create a golf swing that is built just for them.
                                            </p>
                                        </Collapse>
                                    </div>
                                </div>
                                <div className="col-lg-6 accordion-item acc_items">
                                    <div className="points_sec">
                                        <h4 className="custom-collapse" id="fitter_p2">
                                            <span className="collapsed" onClick={() => setOpen1(!open1)} aria-controls="example-collapse-text" aria-expanded={open1}>
                                                What is a match up?
                                                <img className="hide_desktop" src={require('../../assets/images/angle_down.png')} />
                                            </span>
                                        </h4>
                                        <Collapse in={open1}>
                                            <p id="fitter_pc2" className="accordion-collapse collapse" aria-labelledby="fitter_p2">
                                                A match up is moving your body funtionally to help your swing path and club face direction optimally correlate at impact.
                                            </p>
                                        </Collapse>
                                    </div>
                                </div>
                            </div>
                            <div className="card show_mobile">
                                <div className="card-body">
                                    <h4 className="card-title">Interested in lessons?</h4>
                                    <FormMobile />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    );
}

export default GolfLessons;